import React from 'react';

import { Button, SxProps } from '@mui/material';

import Link from './Link';

type ButtonLinkProps = Omit<Parameters<typeof Button>[0], 'href' | 'component'>;

type Props = ButtonLinkProps & {
  href: string;
  linkSx?: SxProps;
  target?: string;
};

export default function ButtonLink({ href, linkSx, target, ...props }: Props): JSX.Element {
  return (
    <Link href={href} sx={linkSx} color="inherit" target={target}>
      <Button {...props} />
    </Link>
  );
}
